import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useGetRecipient = (uid: string) => {
  return useQuery({
    queryKey: ['getRecipient', uid],
    queryFn: () => Api.dictionaries.getRecipient(uid),
    enabled: !!uid,
  });
};
